module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.infoline) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.art.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.art.journal) + " " + _vm._s(_vm.art.volume)), (_vm.art.issue) ? _c('span', [_vm._v("(" + _vm._s(_vm.art.issue) + ")")]) : _vm._e(), _vm._v(":" + _vm._s(_vm.art.firstpage) + "-" + _vm._s(_vm.art.lastpage)), (_vm.art.coauthor) ? _c('span', [_vm._v(" (with " + _vm._s(_vm.art.coauthor) + ")")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.art.year))]), _vm._v(" "), _c('td', [_c('span', {
    on: {
      "click": function($event) {
        _vm.abs()
      }
    }
  }, [_c('img', {
    staticClass: "pubsicon",
    attrs: {
      "src": require("../../assets/icons/file-text.svg")
    }
  })]), _vm._v(" "), (_vm.art.publink) ? _c('a', {
    attrs: {
      "href": _vm.art.publink
    }
  }, [_c('img', {
    staticClass: "pubsicon",
    attrs: {
      "src": require("../../assets/icons/external-link.svg")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.art.altlink) ? _c('a', {
    attrs: {
      "href": _vm.art.altlink
    }
  }, [_c('img', {
    staticClass: "pubsicon",
    attrs: {
      "src": require("../../assets/icons/cloud-download.svg")
    }
  })]) : _vm._e()])]) : _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.art.title))]), _vm._v(" "), _c('h6', [_vm._v("Abstract")]), _vm._v(" "), (_vm.art.abstract) ? _c('p', [_vm._v(_vm._s(_vm.art.abstract))]) : _c('p', [_vm._v("Sorry, I don't have an abstract for this publication.")]), _vm._v(" "), (_vm.art.publink || _vm.art.altlink) ? _c('p', [(_vm.art.publink) ? _c('a', {
    attrs: {
      "href": _vm.art.publink
    }
  }, [_c('button', [_vm._v("Publisher Link")])]) : _vm._e(), _vm._v(" "), (_vm.art.altlink) ? _c('a', {
    attrs: {
      "href": _vm.art.altlink
    }
  }, [_c('button', [_vm._v("Self-Archived Link")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('h6', [_vm._v("Citation")]), _vm._v(" "), _c('p', [_c('newcitation', {
    attrs: {
      "art": _vm.art
    }
  })], 1)]), _vm._v(" "), _c('td', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.line()
      }
    }
  }, [_c('img', {
    staticClass: "pubsicon",
    attrs: {
      "src": require("../../assets/icons/times.svg")
    }
  })]), _vm._v(" "), (_vm.art.publink) ? _c('a', {
    attrs: {
      "href": _vm.art.publink
    }
  }, [_c('img', {
    staticClass: "pubsicon",
    attrs: {
      "src": require("../../assets/icons/external-link.svg")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.art.altlink) ? _c('a', {
    attrs: {
      "href": _vm.art.altlink
    }
  }, [_c('img', {
    staticClass: "pubsicon",
    attrs: {
      "src": require("../../assets/icons/cloud-download.svg")
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c6f3024","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pubs/articlerow.vue
// module id = 189
// module chunks = 0